import script from "./ChatPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatPopup.vue?vue&type=script&setup=true&lang=ts"

import "./ChatPopup.vue?vue&type=style&index=0&id=53785615&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53785615"]])

export default __exports__